import { VisitReviewAddComponent, VisitReviewComponent } from '@app/visit-reviews/components';
import { AddReviewTokenResolver, ReviewReplyTokenResolver, VisitReviewResolver} from '@app/visit-reviews/services';
import { Routes } from "@angular/router";

export const visitReviewsModuleRoutes: Routes = [
  {
    path: 'visit-review/:addReviewToken',
    redirectTo: 'visit-reviews/add/:addReviewToken',
    pathMatch: 'full'
  },
  {
    path: 'visit-reviews',
    children: [
      {
        path: 'add/:addReviewToken',
        data: { bodyCssClass: 'visit-reviews' },
        component: VisitReviewAddComponent,
        resolve: {
          viewData: AddReviewTokenResolver
        }
      },
      {
        path: 'view/:reviewId',
        component: VisitReviewComponent,
        resolve: {
          viewData: VisitReviewResolver
        }
      },
      {
        path: 'reply/:reviewId/:reviewReplyToken',
        component: VisitReviewComponent,
        resolve: {
          viewData: VisitReviewResolver,
          reviewReplyTokenInfo: ReviewReplyTokenResolver
        }
      },
      { path: '**', redirectTo: '/', pathMatch: 'full' }
    ],
  }
];

